// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// <ErrorMessageSnippet>
import * as React from "react";
//import  {Alert}  from 'react-bootstrap';
import { useAppContext } from '../MSGraph/AppContext';

export default function ErrorMessage() {
  const app = useAppContext();

  if (app.error) {
    return (
      // <Alert variant="danger" dismissible onClose={() => app.clearError!()}>
      //   <p className="mb-3">{app.error.message}</p>
      //   {app.error.debug ?
      //     <pre className="alert-pre border bg-light p-2"><code>{app.error.debug}</code></pre>
      //     : null
      //   }
      // </Alert>
      <div>ERROR</div>
    );
  }

  return null;
}
// </ErrorMessageSnippet>
